/**
 * Fixed, full-viewport gradient cloud backdrop for the portal shell.
 *
 * A lightweight CSS stand-in for nmblr.foundation.app's WebGL MeshGradient —
 * the same moody navy/cyan/green palette weighted toward the `#131522` base,
 * rendered with layered `radial-gradient`s (see `.app-gradient` in index.css)
 * so the bundle stays free of a heavy shader dependency.
 *
 * Sits at `-z-10`, `pointer-events-none`, `aria-hidden` — page content renders
 * transparently above it (cards are solid islands), so the cloud peeks around
 * the edges exactly like the single-chat screen.
 */
export function GradientBackdrop() {
  return (
    <div
      aria-hidden="true"
      className="app-gradient fixed inset-0 -z-10 pointer-events-none"
    />
  );
}
